import { TIsSecureContextFactory } from '../types';

export const createIsSecureContext: TIsSecureContextFactory = (window) => window !== null && window.isSecureContext;
